module.exports = __webpack_public_path__ + "img/kantenkontakt.3c443da2.jpg";